// extracted by mini-css-extract-plugin
export default {"productDescription":"aea-z","featuredDescription":"bea-z","description":"cea-z","more":"dea-z","descriptionSku":"eea-z"};